<template>
  <div id="cesiumBodyWar">
    <!-- <div style="position:absolute;right:50px;top:30px;color:white;z-index:9999;">
    <p v-if="radio==rightRadio&&submit==1">当前得分{{score}}</p>
    </div>-->

    <!-- :duration="{ enter: 5000, leave: 8000 }" -->
    <!-- <transition v-if="isMobile" name="fade"> -->
    <!-- <van-button key="s1" plain type="danger" style="position:absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);z-index:9999999999">查看</van-button> -->
    <!-- <img
        v-show="startShow"
        :src="require('./img/jd100start.jpg')"
        alt=""
        style="
          width: 100%;
          height: calc(100% - 110px);
          position: absolute;
          left: 0px;
          top: 33px;
          z-index: 9999999999;
        "
      />
    </transition> -->
     <!-- <transition v-if="isMobile" name="fade"> -->
    <!-- <van-button key="s1" plain type="danger" style="position:absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);z-index:9999999999">查看</van-button> -->
    <!-- <img
        v-show="startShow"
        :src="require('./img/jd100start.jpg')"
        alt=""
        style="
          width: 100%;
          height: calc(100% - 75px);
          position: absolute;
          left: 0px;
          top: 33px;
          z-index: 9999999999;
        "
      />
    </transition> -->

    <!-- <transition v-if="isMobile">
      <div v-show="startShow" alt="" class="mobileshowdiv">
        <div class="timeshow">
          <p class="main-title_3zWFg">喜迎20大</p>
        <p class="sub-title_1U0m1" style="color: #fff">10月16日在京开幕</p>
        <div class="timer-new_2WS5z">
          <span class="title-new_1qnCA">倒计时：</span>
        </div>
         <span> {{counttime}}</span>
        </div>
      </div>
    </transition> -->
    <!-- 开屏图片点击查看七一习近平部分 -->
    <!-- <transition v-if="isMobile" name="fade">
      <van-button
        @click="goto100special()"
        v-show="startShow"
        size="small"
        plain
        type="danger"
        style="
          position: absolute;
          top: 80%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 9999999999;
        "
        >点击查看</van-button
      >
    </transition> -->
<!-- 
    <transition v-if="!isMobile"> 
        <img v-show="startShow" :src="require('./img/jd100startpc.jpg')" alt="" style="min-width:100%;min-height:calc(100% - 110px);position:absolute;left:0px;top:63px;z-index:9999999999">
    </transition> -->
     <!-- <transition v-if="!isMobile"> 
        <img v-show="startShow" :src="require('./img/jd100startpc.jpg')" alt="" style="min-width:100%;min-height:calc(100% - 70px);position:absolute;left:0px;top:33px;z-index:9999999999">
    </transition> -->
    <!-- <transition v-if="!isMobile">
      <div v-show="startShow" alt="" class="startshowdiv">
        <p class="main-title_3zWFg">喜迎20大</p>
        <p class="sub-title_1U0m1" style="color: #fff">10月16日在京开幕</p> -->
        <!-- <div class="timer-new_2WS5z">
          <span class="title-new_1qnCA">倒计时：</span>
        </div>
         <span> {{counttime}}</span> -->
      <!-- </div>
    </transition> -->

    <div
      style="
        background-color: white;
        position: absolute;
        bottom: 60px;
        left: calc(50% - 50px);
        z-index: 999999;
        color: black;
        width: 100px;
        text-align: center;
        height: 25px;
        border-radius: 8px;
      "
      @click="showEnviroment"
    >
      跳转答题
    </div>

    <div id="foot_news">
      <div id="foot_news_close" @click="newClose">关闭</div>
      <iframe src frameborder="0" id="foot_news_src" :src="link" allowfullscreen="true"></iframe>
    </div>
    <div id="toolbar" style="height:22px; width:calc(100% - 35px);margin-left:35px">
      <ul>
        <li id="grow" @click="showGrow" style="font-weight: bold">成长足迹</li>
        <li id="out" @click="showOut" style="font-weight: bold">外交足迹</li>
        <li id="in" @click="showIn" style="font-weight: bold">考察足迹</li>
        <li id="red" @click="showRed" style="font-weight: bold">红色足迹</li>
       <!--<li id="fight" @click="showFight" style="font-weight: bold">
          指挥抗疫
        </li>--> 
      </ul>
      <!-- <ul>
        <li id="grow" @click="showGrow" style="font-weight:bold;">成长</li>
        <li id="out" @click="showOut" style="font-weight:bold;">外交</li>
        <li id="in" @click="showIn" style="font-weight:bold;">考察</li>
        <li id="red" @click="showRed" style="font-weight:bold;">红色</li>
        <li id="fight" @click="showRed" style="font-weight:bold;">指挥</li>
      </ul>
      <ul style="z-index:999999999;">
        <li id="grow" @click="showGrow" style="font-weight:bold;">足迹</li>
        <li id="out" @click="showOut" style="font-weight:bold;">足迹</li>
        <li id="in" @click="showIn" style="font-weight:bold;">足迹</li>
        <li id="red" @click="showRed" style="font-weight:bold;">足迹</li>
        <li id="fight" @click="showRed" style="font-weight:bold;">抗疫</li>
      </ul> -->
    </div>

    <div id="trackPopUp" v-show="ifShowPopUp">
      <div
        id="trackPopUpContent"
        class="leaflet1-popup"
        style="top: 0px; left: 0px"
      >
        <a class="leaflet1-popup-close-button" href="#"></a>
        <div class="leaflet1-popup-content-wrapper">
          <div v-if="type === 'exam'">
            <div
              id="trackPopUpLink"
              @click="showLink"
              class="leaflet1-popup-content"
              style="max-width: 300px"
            >
              题目{{ titleIndex }}:{{ examTitle }}
              <van-radio-group v-model="radio">
                <van-radio name="1" checked-color="#E70202"
                  >A:{{ chooseOne }}</van-radio
                >
                <van-radio name="2" checked-color="#E70202"
                  >B:{{ chooseTwo }}</van-radio
                >
                <van-radio name="3" checked-color="#E70202"
                  >C:{{ chooseThree }}</van-radio
                >
                <van-radio name="4" checked-color="#E70202"
                  >D:{{ chooseFour }}</van-radio
                >
              </van-radio-group>
              <van-button
                v-if="!submit"
                type="danger"
                size="mini"
                @click="submitAnswer"
                >确认</van-button
              >
              <div v-if="submit">
                <span v-if="radio == rightRadio" style="vertical-align: middle">
                  回答正确
                  <van-icon name="passed" />
                </span>
                <span v-else>
                  回答错误
                  <van-icon name="close" />
                </span>
                正确答案：{{ rightAnswer }}
              </div>
              <van-button
                v-if="submit"
                type="danger"
                size="mini"
                @click="nextExam"
                >下一题</van-button
              >
            </div>
          </div>
          <div v-else>
            <div
              id="trackPopUpLink"
              @click="showLink"
              class="leaflet1-popup-content"
              style="max-width: 300px"
            >
              {{ title }}
            </div>
          </div>
        </div>
        <!-- <div class="leaflet1-popup-tip-container">
          <div class="leaflet1-popup-tip"></div>
        </div>-->
      </div>
    </div>

    <div id="cesiumContainer"></div>
  </div>
</template>

<script>
import Addr from "./../utils/getAPI";

import Cesium from "cesium/Cesium";
import widgets from "cesium/Widgets/widgets.css";
import flagPng from "../assets/flag.png";
import fingerPng from "../assets/finger.png";
// import okPng from "../assets/ok.png";

import { Dialog, Toast } from "vant";

import axios from "axios";

export default {
  name: "cesiumContainerWar",
  props: {
    userName: String,
  },
  data() {
    return {
      ///////////////////////////////

      counttimer: null,
      //倒计时
      time: null,
      counttime: null,
      //开头图片
      startShow: true,
      isMobile: true,
      //////////////////////////////
      titleIndex: 1, //答题题目序号
      ifShowPopUp: false,
      //答题开始时间
      startTime: null,
      //答题结束时间
      endTime: null,
      score: 0, //得分
      username: "",
      // apiAddr:"http://localhost:8080/",
      apiAddr: "http://124.223.11.37:8080/",
      examIndex: 0,
      submit: false,
      examTitle: "",
      chooseOne: "",
      chooseTwo: "",
      chooseThree: "",
      chooseFour: "",
      rightAnswer: "",
      rightRadio: "3",
      radio: "1",
      type: "news",
      cartesian: null,
      c: null,
      isPick: false,
      title: null,
      link: null,
      pick: null,
      viewer: null,
      war: [
        // {
        //   id: "1920年",
        //   foottime: "1920年",
        //   place: "天津",
        //   lon: 117.19429500011,
        //   lat: 39.08263399976,
        //   title: "天津",
        //   type: "exam",
        //   examTitle:
        //     "五四时期周恩来在天津创办的刊物是（  ）",
        //   chooseOne: "《互助》",
        //   chooseTwo: "《觉悟》",
        //   chooseThree: "《新生活》",
        //   chooseFour: "《每周评论》",
        //   rightRadio: "2",
        //   link: ""
        // },
        {
          id: "1924年5月",
          foottime: "1924年5月",
          place: "广州",
          lon: 113.24940871428335,
          lat: 23.12141660875347,
          title: "广州",
          type: "exam",
          examTitle: "1924年5月黄埔军校正式成立，其党代表是（  ）",
          chooseOne: "汪精卫",
          chooseTwo: "周恩来",
          chooseThree: "廖仲恺",
          chooseFour: "胡汉民",
          rightRadio: "3",
          link: "",
        },
        {
          id: "1927年10月",
          foottime: "1927年10月",
          place: "井冈山",
          lon: 114.28441299986,
          lat: 26.75147700036,
          title: "井冈山",
          type: "exam",
          examTitle: "井冈山革命根据地的创建，最主要的意义是（  ）",
          chooseOne: "开始游击战争的尝试",
          chooseTwo: "揭开了中国革命从城市转入农村的序幕",
          chooseThree: "创建人民军队的开始",
          chooseFour: "点燃了“工农武装割据”的星星之火",
          rightRadio: "4",
          link: "",
        },
        {
          id: "1935年1月",
          foottime: "1935年1月",
          place: "遵义",
          lon: 106.9234019996,
          lat: 27.7289750003,
          title: "遵义",
          type: "exam",
          examTitle:
            "遵义会议在中国革命史上具有非常重要的历史意义，下列关于遵义会议叙述不准确的是（  ）。",
          chooseOne: "解决了博古等人在军事上和组织上的错误",
          chooseTwo: "确定了毛泽东思想为党的指导思想",
          chooseThree: "确定了以毛泽东为核心的党中央的正确领导",
          chooseFour: "这次会议挽救了党、挽救了红军、挽救了革命",
          rightRadio: "2",
          link: "",
        },

        {
          id: "2013年4月10日",
          foottime: "2013年4月10日",
          place: "海南",
          lon: 110.4345760362,
          lat: 19.2696732048,
          title: "海南",
          type: "exam",
          examTitle:
            "2013年4月8日至10日，习近平总书记在海南考察时指出：“保护生态环境就是保护生产力，（）就是发展生产力。”",
          chooseOne: "改善生态环境",
          chooseTwo: "提高科技水平",
          chooseThree: "大力发展经济",
          chooseFour: "发展对外贸易​",
          rightRadio: "1",
          link: "",
        },
        {
          id: "2013年9月7日",
          foottime: "2013年9月7日",
          place: "哈萨克斯坦",
          lon: 71.4457,
          lat: 51.1807,
          title: "哈萨克斯坦",
          type: "exam",
          examTitle:
            "2013年9月7日习近平总书记在哈萨克斯坦纳扎尔巴耶夫大学发表演讲并回答学生们提出的问题，在谈到环境保护问题时他指出：（）",
          chooseOne:
            "“我们既要绿水青山，也要金山银山。宁要绿水青山，不要金山银山，而且绿水青山就是金山银山。”",
          chooseTwo:
            "“像保护眼睛一样保护生态环境，像对待生命一样对待生态环境。”",
          chooseThree:
            "“保护生态环境就是保护生产力，改善生态环境就是发展生产力。”",
          chooseFour: "“我们不能吃祖宗饭、断子孙路，用破坏性方式搞发展。”",
          rightRadio: "1",
          link: "",
        },
        {
          id: "2015年2月13日",
          foottime: "2015年2月13日",
          place: "陕西延安",
          lon: 109.51189041137697,
          lat: 36.54936246839778,
          title: "陕西延安",
          type: "exam",
          examTitle:
            "2015年2月13日，习近平总书记在陕甘宁革命老区脱贫致富座谈会上强调：“推动陕甘宁革命老区发展，必须结合自然条件和资源分布，科学谋划、合理规划，在发展中要坚决守住生态红线，让天高云淡、（）、牛羊成群始终成为黄土高原的特色风景。”",
          chooseOne: "枝繁叶茂",
          chooseTwo: "草木成荫",
          chooseThree: "碧水蓝天",
          chooseFour: "山清水秀",
          rightRadio: "2",
          link: "",
        },
        {
          id: "2018年2月14日",
          foottime: "2018年2月14日",
          place: "四川",
          lon: 102.4564309061138,
          lat: 27.6543381066919,
          title: "四川",
          type: "exam",
          examTitle:
            "习近平来到四川看望慰问各族干部群众，向全国各族人民致以美好的新春视福、习近平强调，我国经济已由高速增长阶段转向高质量发展阶段，建设（）是我国发展的战略目标。",
          chooseOne: "共享经济体系",
          chooseTwo: "规模化经济体系",
          chooseThree: "资源型经济体系",
          chooseFour: "现代化经济体系",
          rightRadio: "4",
          link: "",
        },
        {
          id: "2018年5月2日",
          foottime: "2018年5月2日",
          place: "北京",
          lon: 116.39153189712952,
          lat: 39.907234384502566,
          title: "北京",
          type: "exam",
          examTitle:
            "习近平总书记在北京大学师生座谈会上对青年提的几点希望不包括?（）",
          chooseOne: "爱国，忠于祖国，忠于人民",
          chooseTwo: "励志，立鸿鸽志，做奋斗者",
          chooseThree: "求真，求真学间，练真本事",
          chooseFour: "务实，实事求是，做实干者",
          rightRadio: "4",
          link: "",
        },
        {
          id: "2018年9月25日",
          foottime: "2018年9月25日",
          place: "黑龙江",
          lon: 132.645584,
          lat: 47.256168,
          title: "黑龙江",
          type: "exam",
          examTitle:
            "2018年9月25日，习近平抵达黑龙江省开始考察。当天下午，他首先来到黑龙江农垦建三江管理局，了解粮食生产和收获情况。建三江地处三江平原腹地，是我国重要商品粮基地，有（）之称。",
          chooseOne: "中国粮食之都",
          chooseTwo: "中国生态城市",
          chooseThree: "中国绿色米都",
          chooseFour: "中国产粮基地",
          rightRadio: "3",
          link: "",
        },
        {
          id: "2019年3月26日",
          foottime: "2019年3月26日",
          place: "巴黎",
          lon: 2.41123,
          lat: 48.8843,
          title: "巴黎",
          type: "exam",
          examTitle:
            "2019年3月26日，国家主席习近平在巴黎同法国总统马克龙一道出席（）闭幕式。德国总理默克尔、欧盟委员会主席容克应邀出席。习近平和马克龙、默克尔、容克在热烈掌声中，共同步入闭幕式现场。",
          chooseOne: "中法文化论坛",
          chooseTwo: "中法全球管理论坛",
          chooseThree: "中法全球治理论坛",
          chooseFour: "中法品牌高峰论坛",
          rightRadio: "3",
          link: "",
        },
      ],

      // war: [
      //   {
      //     id: "2013年4月10日",
      //     foottime: "2013年4月10日",
      //     place: "海南",
      //     lon: 110.4345760362,
      //     lat: 19.2696732048,
      //     title: "海南",
      //     type: "exam",
      //     examTitle:
      //       "2013年4月8日至10日，习近平总书记在海南考察时指出：“保护生态环境就是保护生产力，（）就是发展生产力。”",
      //     chooseOne: "改善生态环境",
      //     chooseTwo: "提高科技水平",
      //     chooseThree: "大力发展经济",
      //     chooseFour: "发展对外贸易​",
      //     rightRadio: "1",
      //     link: ""
      //   },
      //   {
      //     id: "2013年9月7日",
      //     foottime: "2013年9月7日",
      //     place: "哈萨克斯坦",
      //     lon: 71.4457,
      //     lat: 51.1807,
      //     title: "哈萨克斯坦",
      //     type: "exam",
      //     examTitle:
      //       "2013年9月7日习近平总书记在哈萨克斯坦纳扎尔巴耶夫大学发表演讲并回答学生们提出的问题，在谈到环境保护问题时他指出：（）",
      //     chooseOne:
      //       "“我们既要绿水青山，也要金山银山。宁要绿水青山，不要金山银山，而且绿水青山就是金山银山。”",
      //     chooseTwo:
      //       "“像保护眼睛一样保护生态环境，像对待生命一样对待生态环境。”",
      //     chooseThree:
      //       "“保护生态环境就是保护生产力，改善生态环境就是发展生产力。”",
      //     chooseFour: "“我们不能吃祖宗饭、断子孙路，用破坏性方式搞发展。”",
      //     rightRadio: "1",
      //     link: ""
      //   },
      //   {
      //     id: "2015年2月13日",
      //     foottime: "2015年2月13日",
      //     place: "陕西延安",
      //     lon: 109.51189041137697,
      //     lat: 36.54936246839778,
      //     title: "陕西延安",
      //     type: "exam",
      //     examTitle:
      //       "2015年2月13日，习近平总书记在陕甘宁革命老区脱贫致富座谈会上强调：“推动陕甘宁革命老区发展，必须结合自然条件和资源分布，科学谋划、合理规划，在发展中要坚决守住生态红线，让天高云淡、（）、牛羊成群始终成为黄土高原的特色风景。”",
      //     chooseOne: "枝繁叶茂",
      //     chooseTwo: "草木成荫",
      //     chooseThree: "碧水蓝天",
      //     chooseFour: "山清水秀",
      //     rightRadio: "2",
      //     link: ""
      //   }
      // ],

      grow: [],
      inData: [],
      redData: [],
      out: [],
      enviroment: [],
    };
  },
  methods: {
    // countDownStart() {
    //   count++;
    //   let offset = new Date().getTime() - (startTime + count * interval);
    //   let nextTime = interval - offset;
    //   if (nextTime < 0) {
    //     nextTime = 0;
    //   }
    //   ms -= interval;
    //   console.log("误差：" + offset + "ms");
    //   if (ms < 0) {
    //     clearTimeout(timeCounter);
    //   } else {
    //     timeCounter = setTimeout(countDownStart, nextTime);
    //   }
    // },

    // countDown(time) {
    //   var times = parseFloat(time);
    //   var d = parseInt(times / 60 / 60 / 24); // 天

    //   d = d < 10 ? "0" + d : d;
    //   var h = parseInt((times / 60 / 60) % 24); //时
    //   h = h < 10 ? "0" + h : h;
    //   var m = parseInt((times / 60) % 60); // 分
    //   m = m < 10 ? "0" + m : m;
    //   var s = parseInt(times % 60); // 当前的秒
    //   s = s < 10 ? "0" + s : s;
    //   this.counttime = d + "天" + h + "时" + m + "分" + s + "秒";
    //   console.log("this.counttime", this.counttime);
    //   return this.counttime;
    // },
    getcounttimer(){
          this.counttimer = window.setInterval(() => {
            setTimeout(this.inittime(), 0);
          },1000);
    },
    //倒计时
    // inittime() {
    //   var _that = this;
    //   axios
    //     .get(Addr.getGoNewAPIPrefix() + "partytime/getpartytime")
    //     .then((res) => {
    //       if (parseFloat(res.data) <= 0) {
    //         this.stop();
    //       }
    //       var times = parseFloat(res.data);
    //       var d = parseInt(times / 60 / 60 / 24); // 天

    //       d = d < 10 ? "0" + d : d;

    //       var h = parseInt((times / 60 / 60) % 24); //时
    //       h = h < 10 ? "0" + h : h;

    //       var m = parseInt((times / 60) % 60); // 分
    //       m = m < 10 ? "0" + m : m;

    //       var s = parseInt(times % 60); // 当前的秒
    //       s = s < 10 ? "0" + s : s;

    //       _that.counttime = d + "天" + h + "时" + m + "分" + s + "秒";
    //        console.log('_that.counttime',_that.counttime)
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    //停止倒计时
    stop() {
      clearInterval(this.counttimer);
      this.counttimer = null;
    },
    goto100special() {
      localStorage.setItem("goto100special", "yes");
      this.$router.push("/course");
    },
    nextExam() {
      console.log("username is:");
      console.log(this.username);
      if (this.examIndex + 1 >= this.war.length) {
        this.isPick = false;
        // document.getElementById("trackPopUp").style.display = "none";
        this.ifShowPopUp = false;
        // this.submit = false;
        this.radio = "1";
        this.link = "";

        Dialog({ message: "题目已答完,最终得分:" + this.score });

        //最终时间
        this.endTime = new Date().getTime();

        if (
          this.username.indexOf("xijingpingxijingping") != -1 ||
          this.username == ""
        ) {
          console.log("no returnScore");
        } else {
          console.log("returnScore");
          //实验成绩返回
          axios
            .get(
              this.apiAddr +
                "/ilabx/recordScore?username=" +
                this.username +
                "&score=" +
                this.score +
                "&startTime=" +
                this.startTime +
                "&endTime=" +
                this.endTime
            )
            .then((res) => {
              console.log("res is:");
              console.log(res);
              if (res.data && res.data.code == 0) {
              } else {
                Dialog({ message: "实验结果提交存在问题" });
              }
            })
            .catch((err) => {
              console.log(err);
            });
          // //实验状态判断   是否已提交过分数
          // axios
          //   .get(
          //     this.apiAddr +
          //       "/ilabx/returnState?username=" +
          //       this.username
          //   )
          //   .then(res => {
          //     console.log("res is:");
          //     console.log(res);
          //     if (res.data.code == 0 || res.data.code == 7) {
          //       // Toast({
          //       //   message: "实验状态反馈成功",
          //       //   position: "bottom",
          //       //   duration: 800
          //       // });
          //       if (res.data.code == 0) {

          //       }
          //     } else {
          //       Toast({
          //         message: "实验状态获取存在问题",
          //         position: "bottom",
          //         duration: 800
          //       });
          //     }
          //   })
          //   .catch(err => {
          //     console.log(err);
          //   });
        }
      }
      //this.viewer.entities.removeAll();
      this.examIndex++;
      this.addFootPrint(this.war[this.examIndex]);

      this.viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(
          this.war[this.examIndex].lon,
          this.war[this.examIndex].lat,
          99500
        ),
        orientation: {
          heading: Cesium.Math.toRadians(0),
          pitch: Cesium.Math.toRadians(-90),
          roll: 0.0,
        },
      });

      this.submit = false;
      this.radio = "1";

      //题目序号自加
      this.titleIndex++;

      this.link = "";
      document.getElementById("foot_news").style.display = "none";
    },
    submitAnswer() {
      if (this.startTime == null) {
        this.startTime = new Date().getTime();
      }
      // //如果用户未登录，则提示无法答题
      // if(this.username==""||this.username==undefined){
      //   Dialog({ message: "未登录!无法答题!" });
      //   return;
      // }
      console.log("radio is");
      console.log(this.radio);
      console.log("right radio is");
      console.log(this.rightRadio);

      if (this.radio == this.rightRadio) {
        this.score += 10;
      }
      this.submit = true;
    },
    showWar() {
      this.startTime = null;
      this.endTime = null;

      this.score = 0; //得分清零
      Toast({
        message: "点击位置标注进行答题",
        icon: fingerPng,
      });
      console.log("war");
      //this.viewer.entities.removeAll();
      this.examIndex = 0;
      this.addFootPrint(this.war[this.examIndex]);
      this.submit = false;
      this.radio = "1";
      this.link = "";

      this.viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(
          this.war[0].lon,
          this.war[0].lat,
          99500
        ),
        orientation: {
          heading: Cesium.Math.toRadians(0),
          pitch: Cesium.Math.toRadians(-90),
          roll: 0.0,
        },
      });

      // // Override behavior of home button
      // this.viewer.homeButton.viewModel.command.beforeExecute.addEventListener(
      //   commandInfo => {
      //     this.viewer.camera.flyTo({
      //       destination: Cesium.Cartesian3.fromDegrees(
      //         this.war[0].lon,
      //         this.war[0].lat,
      //         99500
      //       ),
      //       orientation: {
      //         heading: Cesium.Math.toRadians(0),
      //         pitch: Cesium.Math.toRadians(-90),
      //         roll: 0.0
      //       }
      //     });
      //     // Tell the home button not to do anything
      //     commandInfo.cancel = true;
      //   }
      // );
    },
    newClose() {
      this.link = "";
      document.getElementById("foot_news").style.display = "none";
    },
    showLinkNews() {
      if (this.link == "") {
        return;
      }
      document.getElementById("foot_news").style.display = "block";
    },
    showLink() {
      this.showLinkNews();
      console.log("news tick");
    },
    leftClickEvent(position) {
      console.log("first position is:");
      console.log(position);
      let scene = this.viewer.scene;
      let handler = new Cesium.ScreenSpaceEventHandler(scene.canvas);

      this.isPick = false;
      // document.getElementById("trackPopUp").style.display = "none";
      this.ifShowPopUp = false;

      this.pick = scene.pick(position);

      console.log("pick is:");
      // console.log(this.pick);
      // console.log(this.viewer.entities._entities._array);

      if (this.pick && this.pick.id._id.indexOf("^^") != -1) {
        if (this.pick.id.type && this.pick.id.type == "exam") {
          this.type = "exam";
          this.examTitle = this.pick.id.examTitle;
          this.chooseOne = this.pick.id.chooseOne;
          this.chooseTwo = this.pick.id.chooseTwo;
          this.chooseThree = this.pick.id.chooseThree;
          this.chooseFour = this.pick.id.chooseFour;
          this.rightRadio = this.pick.id.rightRadio;
          if (this.rightRadio == "1") this.rightAnswer = this.chooseOne;
          if (this.rightRadio == "2") this.rightAnswer = this.chooseTwo;
          if (this.rightRadio == "3") this.rightAnswer = this.chooseThree;
          if (this.rightRadio == "4") this.rightAnswer = this.chooseFour;
        } else {
          this.type = "news";
        }
        //选中某模型
        this.isPick = true;
        // document.getElementById("trackPopUp").style.display = "block"; //new*************************
        this.ifShowPopUp = true;

        //飞行靠近
        let pickPos = scene.pickPosition(position);
        let ellipsoid = this.viewer.scene.globe.ellipsoid;
        this.cartesian = ellipsoid.cartesianToCartographic(pickPos);
        // console.log("cartesian is:");
        // console.log(this.cartesian);
        // console.log("pickPos is:");
        // console.log(pickPos);

        // viewer.camera.flyTo({
        // 	destination: Cesium.Cartesian3.fromDegrees(Cesium.Math.toDegrees(cartesian.longitude), Cesium.Math.toDegrees(cartesian.latitude), 250000.0),//5000000.0 350000.0
        // 	orientation: {
        // 		heading: Cesium.Math.toRadians(0),
        // 		pitch: Cesium.Math.toRadians(-90),
        // 		roll: 0.0
        // 	}
        // });

        //viewer.zoomTo(viewer.entities.getById(pick.id._id));

        //viewer.flyTo(pick);

        let mark = this.viewer.entities._entities._array;

        for (var i = 0; i < mark.length; i++) {
          if (mark[i]._id == this.pick.id._id) {
            var ellipsoid = this.viewer.scene.globe.ellipsoid;
            this.cartesian = ellipsoid.cartesianToCartographic(
              mark[i].position._value
            );

            // console.log("war 0 is:");
            // console.log(mark[i].position._value);

            this.viewer.camera.flyTo({
              destination: Cesium.Cartesian3.fromDegrees(
                Cesium.Math.toDegrees(this.cartesian.longitude),
                Cesium.Math.toDegrees(this.cartesian.latitude),
                107500.0
              ), //5000000.0 350000.0
              orientation: {
                heading: Cesium.Math.toRadians(0),
                pitch: Cesium.Math.toRadians(-90),
                roll: 0.0,
              },
            });

            // viewer.flyTo(mark[i]);
            // console.log("position is:");
            // console.log(mark[i].position);
            // var ellipsoid = viewer.scene.globe.ellipsoid;
            // cartesian = ellipsoid.cartesianToCartographic(mark[i].position._value);
            // console.log("cartesian is:");
            // cartesian.height=Math.ceil(viewer.camera.positionCartographic.height);
            // console.log(cartesian);
          }
        }

        //viewer.flyTo(pick)

        this.title = this.pick.id._id.split("^^")[0];
        this.link = this.pick.id._id.split("^^")[1];
        
        //如果link为空则不弹出气泡20190803 and title 加上》》
        console.log("this.type is");
        console.log(this.type);
        console.log("this.link is");
        console.log(this.link);
        if (this.link == "" && this.type == "news") {
          // document.getElementById("trackPopUp").style.display = "none";
          this.ifShowPopUp = false;
          return;
        }
        this.title = this.title + " >>";

        // document.getElementById("trackPopUp").style.display = "none";

        this.c = Cesium.SceneTransforms.wgs84ToWindowCoordinates(
          this.viewer.scene,
          Cesium.Cartesian3.fromDegrees(
            Cesium.Math.toDegrees(this.cartesian.longitude),
            Cesium.Math.toDegrees(this.cartesian.latitude)
          )
        );

        console.log("leftclick");

        this.positionPopUp(this.c);

        return;
        // console.log("pick");
        // console.log(pick.id._id);
        // $("#foot_news_src").attr("src", pick.id._id);
        // $("#foot_news").show();
      } else {
        console.log("no-pick");
        this.isPick = false;
        // document.getElementById("trackPopUp").style.display = "none";
        this.ifShowPopUp = false;
      }
    },

    popWindow() {
      let scene = this.viewer.scene;
      let handler = new Cesium.ScreenSpaceEventHandler(scene.canvas);
      handler.setInputAction((movement) => {
        this.isPick = false;
        // document.getElementById("trackPopUp").style.display = "none";
        this.ifShowPopUp = false;
      }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

      handler.setInputAction((movement) => {
        this.leftClickEvent(movement.position);
      }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
    },
    positionPopUp(c) {
      // console.log("c is:");
      // console.log(c);
      // console.log(document.getElementById("trackPopUpContent").offsetHeight);
      // console.log(document.getElementById("trackPopUpContent").offsetWidth);
      //说明 https://blog.csdn.net/yhn1121/article/details/52774804
      //document.getElementById("trackPopUpContent").style.width 只能获取定义在style中属性值
      //20180508new
      if (c) {
        var x =
          c.x - document.getElementById("trackPopUpContent").offsetWidth / 2;
        var y = c.y - document.getElementById("trackPopUpContent").offsetHeight;
        document.getElementById("trackPopUpContent").style.transform =
          "translate3d(" + x + "px, " + y + "px, 0)";
        // document.getElementById("trackPopUp").style.display = "block";
        this.ifShowPopUp = true;
      }
    },
    showGrow() {
      this.submit = false;
      console.log("grow");
      this.viewer.entities.removeAll();
      this.grow.forEach((item) => {
        this.addFootPrint(item);
      }, this);
      this.addFootLine(this.grow);

      this.viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(
          115.0488065251,
          32.9902332527,
          3500000.0
        ),
        orientation: {
          heading: Cesium.Math.toRadians(0),
          pitch: Cesium.Math.toRadians(-90),
          roll: 0.0,
        },
      });

      // Override behavior of home button
      this.viewer.homeButton.viewModel.command.beforeExecute.addEventListener(
        (commandInfo) => {
          this.viewer.camera.flyTo({
            destination: Cesium.Cartesian3.fromDegrees(
              115.0488065251,
              32.9902332527,
              3500000.0
            ),
            orientation: {
              heading: Cesium.Math.toRadians(0),
              pitch: Cesium.Math.toRadians(-90),
              roll: 0.0,
            },
          });
          
          // Tell the home button not to do anything
          commandInfo.cancel = true;
        }
      );
    },
    showOut() {
      this.submit = false;
      console.log("out");
      this.viewer.entities.removeAll();
      this.out.forEach((item) => {
        this.addFootPrint(item);
      }, this);
      this.addFootLine(this.out);

      this.viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(
          67.678946,
          33.930445,
          20000000.0
        ),
        orientation: {
          heading: Cesium.Math.toRadians(0),
          pitch: Cesium.Math.toRadians(-90),
          roll: 0.0,
        },
      });

      // Override behavior of home button
      this.viewer.homeButton.viewModel.command.beforeExecute.addEventListener(
        (commandInfo) => {
          this.viewer.camera.flyTo({
            destination: Cesium.Cartesian3.fromDegrees(
              67.678946,
              33.930445,
              20000000.0
            ),
            orientation: {
              heading: Cesium.Math.toRadians(0),
              pitch: Cesium.Math.toRadians(-90),
              roll: 0.0,
            },
          });
          // Tell the home button not to do anything
          commandInfo.cancel = true;
        }
      );
    },
    showIn() {
      this.submit = false;
      console.log("in");
      this.viewer.entities.removeAll();
      this.inData.forEach((item) => {
        this.addFootPrint(item);
      }, this);
      this.addFootLine(this.inData);

      this.viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(
          115.0488065251,
          32.9902332527,
          8000000.0
        ),
        orientation: {
          heading: Cesium.Math.toRadians(0),
          pitch: Cesium.Math.toRadians(-90),
          roll: 0.0,
        },
      });

      // Override behavior of home button
      this.viewer.homeButton.viewModel.command.beforeExecute.addEventListener(
        (commandInfo) => {
          this.viewer.camera.flyTo({
            destination: Cesium.Cartesian3.fromDegrees(
              115.0488065251,
              32.9902332527,
              8000000.0
            ),
            orientation: {
              heading: Cesium.Math.toRadians(0),
              pitch: Cesium.Math.toRadians(-90),
              roll: 0.0,
            },
          });
          // Tell the home button not to do anything
          commandInfo.cancel = true;
        }
      );
    },
    showFight() {
      this.submit = false;
      console.log("red");
      this.viewer.entities.removeAll();
      this.fight.forEach((item) => {
        this.addFootPrint(item);
      }, this);
      this.addFootLineDash(this.fight);

      this.viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(
          115.0488065251,
          32.9902332527,
          5000000.0
        ),
        orientation: {
          heading: Cesium.Math.toRadians(0),
          pitch: Cesium.Math.toRadians(-90),
          roll: 0.0,
        },
      });

      // Override behavior of home button
      this.viewer.homeButton.viewModel.command.beforeExecute.addEventListener(
        (commandInfo) => {
          this.viewer.camera.flyTo({
            destination: Cesium.Cartesian3.fromDegrees(
              115.0488065251,
              32.9902332527,
              5000000.0
            ),
            orientation: {
              heading: Cesium.Math.toRadians(0),
              pitch: Cesium.Math.toRadians(-90),
              roll: 0.0,
            },
          });
          // Tell the home button not to do anything
          commandInfo.cancel = true;
        }
      );
    },
    showRed() {
      this.submit = false;
      console.log("red");
      this.viewer.entities.removeAll();
      this.redData.forEach((item) => {
        this.addFootPrint(item);
      }, this);
      this.addFootLine(this.redData);

      this.viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(
          115.0488065251,
          32.9902332527,
          9000000.0
        ),
        orientation: {
          heading: Cesium.Math.toRadians(0),
          pitch: Cesium.Math.toRadians(-90),
          roll: 0.0,
        },
      });

      // Override behavior of home button
      this.viewer.homeButton.viewModel.command.beforeExecute.addEventListener(
        (commandInfo) => {
          this.viewer.camera.flyTo({
            destination: Cesium.Cartesian3.fromDegrees(
              115.0488065251,
              32.9902332527,
              9000000.0
            ),
            orientation: {
              heading: Cesium.Math.toRadians(0),
              pitch: Cesium.Math.toRadians(-90),
              roll: 0.0,
            },
          });
          // Tell the home button not to do anything
          commandInfo.cancel = true;
        }
      );

    },
    showEnviroment() {
      //重置题目序号
      this.titleIndex = 1;
      this.submit = false;
      console.log("environment");
      this.viewer.entities.removeAll();
      // this.enviroment.forEach(item => {
      //   this.addFootPrint(item);
      // }, this);
      // this.addFootLine(this.enviroment);

      // this.viewer.camera.flyTo({
      //   destination: Cesium.Cartesian3.fromDegrees(
      //     115.0488065251,
      //     32.9902332527,
      //     5000000.0
      //   ),
      //   orientation: {
      //     heading: Cesium.Math.toRadians(0),
      //     pitch: Cesium.Math.toRadians(-90),
      //     roll: 0.0
      //   }
      // });

      this.showWar();

      // Override behavior of home button
      this.viewer.homeButton.viewModel.command.beforeExecute.addEventListener(
        (commandInfo) => {
          this.viewer.camera.flyTo({
            destination: Cesium.Cartesian3.fromDegrees(
              115.0488065251,
              32.9902332527,
              5000000.0
            ),
            orientation: {
              heading: Cesium.Math.toRadians(0),
              pitch: Cesium.Math.toRadians(-90),
              roll: 0.0,
            },
          });
          // Tell the home button not to do anything
          commandInfo.cancel = true;
        }
      );
    },
    addFootPrint(item) {
      // console.log("item is");
      // console.log(item);

      // var redLine = viewer.entities.add({
      // 	name: 'Red arrow',
      // 	polyline: {
      // 		positions: Cesium.Cartesian3.fromDegreesArrayHeights([beijingLocation.longitude, beijingLocation.latitude, 1500,
      // 		item.lon, item.lat, 1500]),
      // 		width: 5,
      // 		followSurface: true,
      // 		material: new Cesium.PolylineArrowMaterialProperty(Cesium.Color.RED)
      // 	}

      // });

      var image = new Image();
      image.src = flagPng;
      image.onload = () => {
        this.viewer.entities.add({
          //答题相关的绑定
          examTitle: item.examTitle,
          chooseOne: item.chooseOne,
          chooseTwo: item.chooseTwo,
          chooseThree: item.chooseThree,
          chooseFour: item.chooseFour,
          rightRadio: item.rightRadio,

          type: item.type, //类型 news or exam
          id: item.title + "^^" + item.link,
          position: Cesium.Cartesian3.fromDegrees(item.lon, item.lat, 97500),
          billboard: {
            position: Cesium.Cartesian3.fromDegrees(item.lon, item.lat, 97500),
            scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1.0, 1.5e7, 0.8), //(1.5e2, 5.0, 1.5e7, 0.5)
            alignedAxis: Cesium.Cartesian3.ZERO,
            image: image,
          },
          label: {
            text: item.foottime + " " + item.place, //item.title,
            font: "14px monospace",
            showBackground: true,
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            pixelOffset: new Cesium.Cartesian2(0.0, -image.height),
            pixelOffsetScaleByDistance: new Cesium.NearFarScalar(
              1.5e2,
              1.0,
              1.5e7,
              0.8
            ),
            scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1.1, 1.5e7, 0.0),
          },
        });
      };
    },
    addFootLine(pointArr) {
      console.log("addFootLine");
      for (var i = 0; i < pointArr.length - 1; i++) {
        let redLine = this.viewer.entities.add({
          name: "Red arrow",
          polyline: {
            positions: Cesium.Cartesian3.fromDegreesArrayHeights([
              pointArr[i].lon,
              pointArr[i].lat,
              97500,
              pointArr[i + 1].lon,
              pointArr[i + 1].lat,
              97500,
            ]),
            width: 5,
            followSurface: true,
            material: new Cesium.PolylineArrowMaterialProperty(
              Cesium.Color.RED
            ),
          },
        });
      }
    },
    addFootLineDash(pointArr) {
      console.log("addFootLineDash");
      for (var i = 0; i < pointArr.length; i++) {
        //如果是实地到达的，就是实线
        if (pointArr[i].arrive && pointArr[i].arrive == 1) {
          let redLine = this.viewer.entities.add({
            name: "Red arrow",
            polyline: {
              positions: Cesium.Cartesian3.fromDegreesArrayHeights([
                116.39153,
                39.90723,
                97500,
                pointArr[i].lon,
                pointArr[i].lat,
                97500,
              ]),
              width: 7,
              followSurface: true,
              material: new Cesium.PolylineArrowMaterialProperty(
                Cesium.Color.RED
              ),
            },
          });
        } else {
          let redLine = this.viewer.entities.add({
            name: "Red arrow",
            polyline: {
              positions: Cesium.Cartesian3.fromDegreesArrayHeights([
                116.39153,
                39.90723,
                97500,
                pointArr[i].lon,
                pointArr[i].lat,
                97500,
              ]),
              width: 2,
              followSurface: true,
              material: new Cesium.PolylineDashMaterialProperty({
                color: Cesium.Color.RED,
              }),
            },
          });
        }
      }
    },
  },
  created() {
    // this.getcounttimer()

    axios
      .get(Addr.getGoNewAPIPrefix() + "xi/listXiSubject")
      .then((res) => {
        console.log("war res is:");
        console.log(res);
        if (res.status == 200) {
          console.log("res.data", res.data);
          console.log("200");
          this.enviroment = res.data.enviroment;
          this.grow = res.data.grow;
          this.inData = res.data.inData;
          this.redData = res.data.redData;
          this.out = res.data.out;

          this.fight = res.data.fight;

          this.showGrow();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },

  mounted() {
    //首先判断是否是chrome浏览器
    let isMobile = {
      Android: function () {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
      },
      any: function () {
        return (
          isMobile.Android() ||
          isMobile.BlackBerry() ||
          isMobile.iOS() ||
          isMobile.Opera() ||
          isMobile.Windows()
        );
      },
    };
    //启动图片
    this.isMobile = isMobile.any();
    //启动图片消失
    setTimeout(() => {
      this.startShow = false;
    }, 3000);

    console.log("username is:");
    // console.log(window.location.href);
    console.log(this.userName);
    this.username = this.userName;
    // this.username = window.location.href.split("?username=")[1];

    this.viewer = new Cesium.Viewer("cesiumContainer", {
      baseLayerPicker: false, //地图切换控件(底图以及地形图)是否显示,默认显示true
      // geocoder: true,

      timeline: false,
      animation: false,
      
      // timeline: true,
      // animation: true,
      // shouldAnimate: true,
    
      vrButton: false,
      sceneModePicker: false,
      infoBox: false,
      scene3DOnly: true,
      navigationHelpButton: false,
      selectionIndicator: false, //entity绿色框框
      homeButton: true,
      fullscreenButton:false,//右下角全屏按钮
      maximumScreenSpaceError: 8, // Temporary workaround for low memory mobile devices - Increase maximum error to 8.
      maximumNumberOfLoadedTiles: 10, // Temporary workaround for low memory mobile devices - Decrease (disable) tile cache.

      // maximumScreenSpaceError: isMobile.any() ? 8 : 1, // Temporary workaround for low memory mobile devices - Increase maximum error to 8.
      // maximumNumberOfLoadedTiles: isMobile.any() ? 10 : 1000 // Temporary workaround for low memory mobile devices - Decrease (disable) tile cache.
    });

    // No depth testing against the terrain to avoid z-fighting
    this.viewer.scene.globe.depthTestAgainstTerrain = true;

    ////////////////////////////////////////////////////////////////////////////////////////////////
    //添加天地图地图作为底图
    let imageryLayers = this.viewer.imageryLayers;
    let baseLayer = imageryLayers.get(0);
    //天地图密码
    //tk=b256e08b9f972a2c4677ab5608a305ff
    let url =
      "http://{s}.tianditu.com/img_w/wmts?service=WMTS&version=1.0.0&request=GetTile&tilematrix={TileMatrix}&layer=img&style={style}&tilerow={TileRow}&tilecol={TileCol}&tilematrixset={TileMatrixSet}&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff";
    let url1 =
      "http://{s}.tianditu.com/cva_w/wmts?service=WMTS&version=1.0.0&request=GetTile&tilematrix={TileMatrix}&layer=cva&style={style}&tilerow={TileRow}&tilecol={TileCol}&tilematrixset={TileMatrixSet}&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff";

    imageryLayers.addImageryProvider(
      new Cesium.WebMapTileServiceImageryProvider({
        url: url,
        layer: "img",
        style: "default",
        format: "tiles",
        tileMatrixSetID: "w",
        // credit: new Cesium.Credit('天地图全球影像服务'),
        subdomains: ["t0", "t1", "t2", "t3", "t4", "t5", "t6", "t7"],
        maximumLevel: 10,
      }),
      1
    );

    imageryLayers.addImageryProvider(
      new Cesium.WebMapTileServiceImageryProvider({
        url: url1,
        layer: "cva",
        style: "default",
        format: "tiles",
        tileMatrixSetID: "w",
        // credit: new Cesium.Credit('天地图全球影像服务'),
        subdomains: ["t0", "t1", "t2", "t3", "t4", "t5", "t6", "t7"],
        maximumLevel: 10,
      }),
      2
    );

    imageryLayers.remove(baseLayer);

    // //首先加载习近平成长路线
    // this.grow.forEach(item => {
    //   this.addFootPrint(item);
    // });

    // this.addFootLine(this.grow);

    // this.viewer.camera.flyTo({
    //   destination: Cesium.Cartesian3.fromDegrees(
    //     115.0488065251,
    //     32.9902332527,
    //     3000000.0
    //   ),
    //   orientation: {
    //     heading: Cesium.Math.toRadians(0),
    //     pitch: Cesium.Math.toRadians(-90),
    //     roll: 0.0
    //   }
    // });

    // // Override behavior of home button
    // this.viewer.homeButton.viewModel.command.beforeExecute.addEventListener(
    //   commandInfo => {
    //     this.viewer.camera.flyTo({
    //       destination: Cesium.Cartesian3.fromDegrees(
    //         115.0488065251,
    //         32.9902332527,
    //         3000000.0
    //       ),
    //       orientation: {
    //         heading: Cesium.Math.toRadians(0),
    //         pitch: Cesium.Math.toRadians(-90),
    //         roll: 0.0
    //       }
    //     });
    //     // Tell the home button not to do anything
    //     commandInfo.cancel = true;
    //   }
    // );

    //this.showWar();
    //this.showEnviroment();
    this.showGrow();

    let removeHandler = this.viewer.scene.postRender.addEventListener(() => {
      if (this.isPick == false) {
        return;
      }
      var changedC = Cesium.SceneTransforms.wgs84ToWindowCoordinates(
        this.viewer.scene,
        Cesium.Cartesian3.fromDegrees(
          Cesium.Math.toDegrees(this.cartesian.longitude),
          Cesium.Math.toDegrees(this.cartesian.latitude)
        )
      );
      //20180508new
      if (this.c) {
        //20180508new
        if (changedC) {
          // If things moved, move the popUp too
          if (this.c.x !== changedC.x || this.c.y !== changedC.y) {
            // console.log("removeHandler");
            this.c = changedC;
            this.positionPopUp(this.c);
          }
        }
      }
    });

    this.popWindow();
  },
  destroyed() {
    //离开页面是销毁
    clearInterval(this.counttimer);
    this.counttimer = null;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import "vant/lib/index.css";

/* .fade-enter-active, .fade-leave-active {
  transition: opacity 15s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
} */

/* .fade-enter-active {
  transition: opacity 2s;
}

.fade-enter{
  opacity: 1;
}

.fade-leave-active {
  transition: opacity 3s;
}

.fade-leave-to {
  opacity: 0.8;
} */

/* 时间轴 */
/* .cesium-timeline-main {
  z-index: 999999999999999999999999999999;
  bottom:120px;
  left:20px;
}

.cesium-timeline-main * {
  z-index: 999999999999999999999999999999;
} */

#toolbar {
  height: 22px;
  /* height: 3%; */
  padding: 5px 0px;
  width: 100%;
  background-color: #e70202;
  line-height: 22px;
}

#toolbar ul {
  padding: 0;
  margin: 0;
  display: flex;
  color: white;
}

#toolbar ul li {
  flex: 1;
  text-align: center;
  list-style-type: none;
  font-size: 12px;
}

#cesiumBodyWar{
  height: 100%;
}
#cesiumContainer {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.cesium-widget-credits {
  display: none !important;
}

.cesium-viewer-geocoderContainer {
  display: none !important;
}

.cesium-viewer-bottom {
  display: none !important;
}

#foot_news {
  position: absolute;
  left: 0px;
  top: 29px;
  height: 100%;
  width: 100%;
  display: none;
  z-index: 100000;
  background-color: white;
}

#foot_news_src {
  width: 100%;
  height: 100%;
}

#foot_news_close {
  color: black;
  height: 30px;
}
/*leaflet风格气泡窗口样式模板*/

.leaflet1-popup {
  z-index: 999;
  position: absolute;
  text-align: center;
}

.leaflet1-popup-close-button {
  position: absolute;
  top: 0;
  right: 0;
  padding: 4px 4px 0 0;
  text-align: center;
  width: 18px;
  height: 14px;
  font: 16px/14px Tahoma, Verdana, sans-serif;
  color: #c3c3c3;
  text-decoration: none;
  font-weight: bold;
  background: transparent;
}

.leaflet1-popup-content-wrapper {
  text-align: center;
  max-height: 200px;
  overflow-y: auto;
  background: white;
  box-shadow: 0 3px 14px rgba(0, 0, 0, 0.4);
  padding: 1px;
  text-align: left;
  border-radius: 12px;
}

.leaflet1-popup-content {
  margin: 13px 19px;
  line-height: 1.4;
 
}

.leaflet1-popup-tip-container {
  margin: 0 auto;
  width: 40px;
  height: 20px;
  position: relative;
  overflow: hidden;
}

.leaflet1-popup-tip {
  background: white;
  box-shadow: 0 3px 14px rgba(0, 0, 0, 0.4);
  width: 17px;
  height: 17px;
  padding: 1px;
  margin: -10px auto 0;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}
.startshowdiv {
  min-width: 100%;
  min-height: calc(100% - 65px);
  position: absolute;
  left: 0px;
  top: 33px;
  z-index: 9999999999;
  background: url(../../src/module-list/img/jd100startpc.jpg) no-repeat center 0px;
  background-position: center 0px;
  background-size: cover;
}
.mobileshowdiv {
  min-width: 100%;
  min-height: calc(100% - 65px);
  position: absolute;
  left: 0px;
  top: 33px;
  z-index: 9999999999;
  background: url(../../src/module-list/img/jd100start.jpg) no-repeat center 0px;
  background-position: center 0px;
  background-size: cover;
}
.timeshow {
}
.main-title_3zWFg {
  font-size: 20px;
  line-height: 29px;
  font-weight: 500;
  color: #fff;
}
.sub-title_1U0m1 {
  line-height: 22px;
  font-size: 13px;
  font-weight: 400;
}
</style>


// WEBPACK FOOTER //
// src/module-list/cesiumContainerWar.vue